import { useRefetchQuery } from "libs/reactQuery";
// import { toast } from "react-hot-toast";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useCreateCoupon } from "../../../apis";
import { CouponType, INITIAL_COUPON_FORM_VALUES } from "../../../constants";
import { CouponFormValues } from "../../../coupons.types";
import { convertCouponFormValuesToCreateRequestBody } from "../../../helpers";
import { CouponForm } from "../../forms";
import { CouponModalProps } from "./CouponModal.types";

const COUPON_FORM_ID = "coupon-form-id";

const CouponModal = ({ couponType, isOpen, onClose }: CouponModalProps) => {
  const { t } = useTranslation();
  const refetchCoupons = useRefetchQuery(["coupons", couponType]);

  const createCoupon = useCreateCoupon({
    onSuccess: () => {
      toast.success(t("Coupon created successfully"));
      onClose();
      refetchCoupons();
    }
  });

  const handleFormSubmit = (formData: CouponFormValues) => {
    createCoupon.mutate(
      convertCouponFormValuesToCreateRequestBody(formData, couponType)
    );
  };

  const getTitle = () => {
    switch (couponType) {
      case CouponType.SharingCoupon:
        return t("Sharings Coupon");
      case CouponType.QuantityResoldCoupon:
        return t("Quantity Resold Coupon");
      case CouponType.AmountResoldCoupon:
        return t("Value Resold Coupon");
      case CouponType.OrdersResoldCoupon:
        return t("Orders Resold Coupon");
      case CouponType.SpendAndSaveCoupon:
        return t("Spend & Save Coupon");
      case CouponType.InfluencerCoupon:
        return t("Influencer Coupon");
      case CouponType.CustomCoupon:
        return t("Custom Coupon");
    }
  };

  return (
    <Modal
      formId={COUPON_FORM_ID}
      isOpen={isOpen}
      title={`${t("New")} ${getTitle()}`}
      isLoading={createCoupon.isLoading}
      okText={"Create"}
      onClose={onClose}
    >
      <CouponForm
        formId={COUPON_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={INITIAL_COUPON_FORM_VALUES}
        couponType={couponType}
      />
    </Modal>
  );
};

export default CouponModal;
